<div class="row">
    <div class="col-xl-4">
        <div class="card card-transparent mb-5">
            <a [routerLink]="" class="card-img-wrapper rounded">
                <div class="img-wrapper-overlay">
                    <div class="overlay-btn-wrapper">
                        <button class="btn btn-facebook mr-1" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
                            </span>
                        </button>
                        <button class="btn btn-twitter ml-1" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['fab', 'twitter']"></fa-icon>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="card-badges card-badges-bottom">
                    <span class="badge badge-pill badge-warning">Warning</span>
                </div>
                <img src="assets/images/stock-photos/stock-1.jpg" class="card-img-top rounded" alt="...">
            </a>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-transparent mb-5">
            <a [routerLink]="" class="card-img-wrapper rounded">
                <div class="img-wrapper-overlay">
                    <div class="overlay-btn-wrapper">
                        <div class="card-title mb-2">Sheldon Fischer</div>
                        <button class="btn btn-pill btn-sm btn-info mt-2" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['fas', 'download']"></fa-icon>
                            </span>
                            <span class="btn-wrapper--label">View Profile</span>
                        </button>
                    </div>
                </div>
                <div class="card-badges">
                    <span class="badge badge-pill badge-neutral-info text-info">Info</span>
                </div>
                <img src="assets/images/stock-photos/stock-2.jpg" class="card-img-top rounded" alt="...">
            </a>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-transparent mb-5">
            <a [routerLink]="" class="card-img-wrapper rounded">
                <div class="img-wrapper-overlay">
                    <div class="overlay-btn-wrapper">
                        <button class="btn btn-pill btn-outline-secondary border-2 mr-1" type="button">
                            <fa-icon [icon]="['far', 'comment-dots']"></fa-icon>
                        </button>
                        <button class="btn btn-pill btn-outline-secondary border-2 ml-1" type="button">
                            <fa-icon [icon]="['far', 'envelope']"></fa-icon>
                        </button>

                    </div>
                </div>
                <div class="card-badges card-badges-bottom">
                    <span class="badge badge-danger">Danger</span>
                </div>
                <img src="assets/images/stock-photos/stock-3.jpg" class="card-img-top rounded" alt="...">
            </a>
        </div>
    </div>
</div>
